// extracted by mini-css-extract-plugin
module.exports = {"required":"table_required__36D3C","removeIcon":"table_removeIcon__3ddut","addBtn":"table_addBtn__3cB1c"};